var map = {
	"./btn-background-black.png": 249,
	"./btn-background-green.png": 250,
	"./first.png": 1576,
	"./header-babaijebu.png": 251,
	"./horse-video.png": 1577,
	"./results.png": 252,
	"./second.png": 1578,
	"./third.png": 1579,
	"./trophy.png": 1580,
	"./vdh-bck.png": 160,
	"./vdh-progress.png": 253
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1575;


//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/img \.(gif|png|jpe?g|svg)$/
// module id = 1575
// module chunks = 7